export default __webpack_public_path__ + "static/media/bank-transfer.0e1a9d10.svg";